import getAllCallerIDs from './get-all-caller-ids'
import getAugmentedPhoneNumbers from './get-augmented-phone-numbers'
import getCorrectedPhoneNumbers from './get-corrected-phone-numbers'
import getNonHLNumbersLookup from './get-non-hl-numbers-lookup'
import getPaginatedCallerIDs from './get-paginated-caller-ids'
import getPaginatedNumberPools from './get-paginated-number-pools'
import getPaginatedPhoneNumbers from './get-paginated-phone-numbers'
import getSearchedCallerIds from './get-searched-caller-ids'
import getSearchedNumberPools from './get-searched-number-pools'
import getSearchedPhoneNumbers from './get-searched-phone-numbers'
import getSortedPhoneNumbers from './get-sorted-phone-numbers'
import verifiedPhoneNumbers from './verified-phone-numbers'
import getPhoneNumberData from './get-phone-number-data'
import getA2PComplianceStatus from './get-a2p-compliance-status'
import getTollFreeData from "./get-tollfree-data"

const getters = {
  getAllCallerIDs,
  getAugmentedPhoneNumbers,
  getCorrectedPhoneNumbers,
  getNonHLNumbersLookup,
  getPaginatedCallerIDs,
  getPaginatedNumberPools,
  getPaginatedPhoneNumbers,
  getSearchedCallerIds,
  getSearchedNumberPools,
  getSearchedPhoneNumbers,
  getSortedPhoneNumbers,
  verifiedPhoneNumbers,
  getPhoneNumberData,
  getTollFreeData,
  getA2PComplianceStatus
}

export default getters
